module.exports = __webpack_public_path__ + "f2bd8299f66e867bf3a015b0ead0b6b4.woff";